<template>
  <div class="large-text">
    <h1 class="m-0">
      {{ title }}
    </h1>
  </div>
</template>

<script>
export default {
  name: "DdCardLargeText",
  props: {
    title: {
      required: true,
    }
  }
}
</script>

<style lang='scss' scoped>
.large-text {
  margin-top: auto;
  margin-bottom: auto;
  h1 {
    line-height: 1;
  }
}
</style>
